<template>
  <div>
    <DashboardHeader title="Budgets">
      <v-layout row wrap v-if="isManager">
        <v-snackbar v-model="snackBar" dark :color="getThemeColor">
          {{ snackText }}
          <v-btn color="pink" text @click="snackBar = false">Close</v-btn>
        </v-snackbar>
        <v-flex xs12 sm3>
          <v-card
            class="mx-4 mt-6"
            v-if="isManager"
            shaped
            elevation="12"
            max-width="344"
            outlined
            :color="getThemeColor"
            dark
          >
            <v-list-item three-line>
              <p>Available Amount: {{getCurrency}} {{totalBudget}}</p>
            </v-list-item>
          </v-card>

          <v-card class="mx-4 mt-6" v-if="isManager" shaped elevation="12" max-width="344" outlined>
            <v-list-item three-line>
              <v-autocomplete
                @change="renderBudgets()"
                :items="categories"
                label="Categories"
                v-model="selectedBudgetCategory"
              ></v-autocomplete>
            </v-list-item>
          </v-card>

          <v-card class="mx-4 mt-6" v-if="isManager" shaped elevation="12" max-width="344" outlined>
            <v-card-title class="ml-4">
              {{title}}
              <v-btn class="mx-4" color="success" rounded small @click="saveExpense()">
                <v-icon>mdi-check</v-icon>
              </v-btn>
            </v-card-title>
            <div class="mx-4">
              <v-list-item three-line>
                <ExpensesCategories @expense-category-selected="getSelectedExpenseCategory"></ExpensesCategories>
                <CreateExpenseCategory class="ml-4"></CreateExpenseCategory>
              </v-list-item>
              <v-list-item three-line>
                <v-text-field class="mr-16" label="Amount" v-model="budgetAmount"></v-text-field>
              </v-list-item>
              <v-list-item three-line>
                <ServiceProviders @service-provider-selected="getSelectedServiceProvider"></ServiceProviders>
                <CreateServiceProvider class="ml-4"></CreateServiceProvider>
              </v-list-item>
              <v-list-item three-line>
                <DatePickerWithMenu @date-selected="getExpenseDate"></DatePickerWithMenu>
              </v-list-item>
            </div>
          </v-card>
        </v-flex>
        <v-flex xs12 sm8 class="mx-4 mt-6">
          <v-row>
            <v-switch
              :disabled="budgets.length < 1"
              v-model="selectAll"
              label="All"
              class="ml-2 mt-8"
              @change="selectAllExpenses()"
            ></v-switch>
            <v-btn
              v-if="isManager"
              @click="openBulkDeleteDialog()"
              x-small
              rounded
              color="red"
              dark
              class="mt-8 ml-2"
            >
              <v-icon left>mdi-delete</v-icon>Bulk
            </v-btn>From:
            <DatePickerWithMenu :default="dateFrom" @date-selected="getFromDate" class="ml-1 mb-4"></DatePickerWithMenu>To:
            <DatePickerWithMenu :default="dateTo" @date-selected="getToDate" class="ml-1 mb-4"></DatePickerWithMenu>
            <v-btn
              v-if="isManager"
              @click="createBudget()"
              x-small
              rounded
              color="success"
              dark
              class="mt-8 ml-2"
            >
              <v-icon left>mdi-plus</v-icon>Budget
            </v-btn>
            <v-spacer></v-spacer>
            <v-text-field
              class="ml-2 mb-4"
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
              style="display:inline"
            ></v-text-field>
          </v-row>

          <v-data-table :headers="headers" :items="budgets" :search="search">
            <template v-slot:item.selection="{item}">
              <v-checkbox class="shrink" :value="item.id" v-model="selectedBudgetItems"></v-checkbox>
            </template>
            <template v-slot:item.profile="{item}">
              <v-icon :color="getThemeColor" @click="editBudget(item)">mdi-pencil</v-icon>
            </template>
            <template v-slot:item.description="{item}">
              <v-text-field @change="updateField(item.id,'description')" v-model="item.description"></v-text-field>
            </template>
            <template v-slot:item.amount="{item}">
              <v-text-field @change="updateField(item.id,'amount')" v-model="item.amount"></v-text-field>
            </template>

            <template v-slot:item.entry="{item}">
              <v-text-field @change="updateField(item.id,'entry')" v-model="item.entry"></v-text-field>
            </template>
            <template v-slot:item.due="{item}">
              <v-text-field @change="updateField(item.id,'due')" v-model="item.due"></v-text-field>
            </template>
            <template v-slot:item.frequency="{item}">
              <v-text-field @change="updateField(item.id,'frequency')" v-model="item.frequency"></v-text-field>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
      <v-dialog v-model="dialog" width="600" persistent>
        <v-card v-if="bulkDelete">
          <v-card-title
            :style="{'background-color':getThemeColor,'color':'white'}"
            class="headline lighten-2"
          >Delete Selected Expenses</v-card-title>
          <v-card-title class="mt-6 mx-4">Number of Selected Expenses: {{selectedExpenses.length}}</v-card-title>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn rounded color="primary" dark @click="closeDialog()">Cancel</v-btn>
            <v-btn rounded color="error" dark @click="deleteBulkNow()">Delete Now</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </DashboardHeader>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import ServiceProviders from "@/components/BudgetAndFinances/Expenses/ServiceProviders.vue";
import ExpensesCategories from "@/components/BudgetAndFinances/Expenses/ExpensesCategories.vue";
import CreateExpenseCategory from "@/components/BudgetAndFinances/Expenses/CreateExpenseCategory.vue";
import CreateServiceProvider from "@/components/BudgetAndFinances/Expenses/CreateServiceProvider.vue";
import DashboardHeader from "@/components/DashboardHeader.vue";
import DatePickerWithMenu from "@/components/myLibrary/DatePickerWithMenu.vue";

export default {
  components: {
    ServiceProviders,
    DashboardHeader,
    ExpensesCategories,
    DatePickerWithMenu,
    CreateExpenseCategory,
    CreateServiceProvider
  },
  computed: {
    isManager() {
      return this.$store.getters.isManager;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getCurrency() {
      return this.$store.getters.getCurrency;
    }
  },
  mounted() {
    this.renderBudgets();
  },
  data() {
    return {
      selectedBudgetCategory: "expense",
      dateFrom: new Date(new Date().getFullYear(), 0, 32)
        .toISOString()
        .substr(0, 10),
      dateTo: new Date(new Date().getFullYear(), 11, 32)
        .toISOString()
        .substr(0, 10),
      rules: [value => !!value || "This Field is Required!"],
      snackBar: false,
      snackText: null,
      budgetID: 0,
      selectedServiceProvider: null,
      selectedExpenseCategory: null,
      budgetAmount: 0,
      budgetDate: new Date().toISOString().substr(0, 10),
      bulkDelete: false,
      dialog: false,
      budgets: [],
      title: "Add Budget Item",
      selectedBudgetItems: [],
      totalBudget: 0,
      search: null,
      selectAll: false,
      fileToBeUploadedName: null,
      fileToBeUploaded: null,
      selectedFile: "Bitsems_Expenses_Data_Upload.xls",
      categories: [
        { text: "Expected Incomes", value: "income" },
        { text: "Expected Expenditures", value: "expense" }
      ],
      headers: [
        { value: "selection" },
        { text: "Profile", value: "profile" },
        {
          text: "Description",
          align: "start",
          value: "description"
        },
        { text: "Amount", value: "amount" },
        { text: "Entry Date", value: "entry" },
        { text: "Due Date", value: "due" },
        { text: "Frequency", value: "frequency" }
      ]
    };
  },
  methods: {
    selectAllExpenses() {
      if (this.selectAll) {
        this.selectedExpenses = [];
        this.expenses.forEach(expense => {
          this.selectedExpenses.push(expense.id);
        });
      } else {
        this.selectedExpenses = [];
      }
    },
    getSelectedServiceProvider(selectedServiceProvider) {
      this.selectedServiceProvider = selectedServiceProvider;
    },
    getSelectedExpenseCategory(selectedExpenseCategory) {
      this.selectedExpenseCategory = selectedExpenseCategory;
    },
    getFromDate(dateFrom) {
      this.dateFrom = dateFrom;
      this.renderBudgets();
    },
    getToDate(dateTo) {
      this.dateTo = dateTo;
      this.renderBudgets();
    },
    getExpenseDate(expenseDate) {
      this.expenseDate = expenseDate;
      this.renderBudgets();
    },
    saveExpense() {
      if (
        this.selectedServiceProvider != null &&
        this.selectedExpenseCategory != null &&
        this.budgetAmount != 0
      ) {
        this.$store.commit("setLoader", true);
        axios
          .postDataWithToken(
            "/auth/save-expense-manual",
            {
              selectedServiceProvider: this.selectedServiceProvider,
              selectedExpenseCategory: this.selectedExpenseCategory,
              budgetAmount: this.budgetAmount,
              expenseDate: this.expenseDate,
              expenseID: this.expenseID
            },
            this.getAccessToken
          )
          .then(data => {
            this.expenses = data.expenses;
            this.totalExpenses = data.totalExp;
            this.resetVariables();
            this.$store.commit("setLoader", false);
          });
      } else {
        alert("All Fields Are Required !!");
        event.preventDefault();
      }
    },
    resetVariables() {
      (this.budgetAmount = 0),
        (this.budgetDate = new Date().toISOString().substr(0, 10));
      this.title = "Add Expense";
      this.budgetID = 0;
    },
    updateField(id, column) {
      const value = event.target.value;
      if (column == "amount") {
        const total = Number(this.totalBudget) + Number(value);
        this.totalBudget = total;
        this.totalBudget = axios.formatMoney(this.totalBudget);
      }
      axios
        .postDataWithToken(
          "/auth/update-item",
          { table: "budgets", id, column, value },
          this.getAccessToken
        )
        .then(response => {
          const nothing = response;
        });
    },
    editBudget(item) {
      (this.selectedServiceProvider = item.service_provider_id),
        (this.selectedExpenseCategory = item.expenses_category_id),
        (this.budgetAmount = item.amount),
        (this.budgetDate = item.entry_date);
      this.title = "Edit Budget Item " + item.id;
      this.budgetID = item.id;
    },
    openBulkDeleteDialog() {
      if (this.selectedExpenses.length < 1) {
        alert("You Must Select At least One(1) Expense!");
        event.preventDefault();
      } else {
        this.dialog = true;
        this.bulkDelete = true;
      }
    },
    closeDialog() {
      this.dialog = false;
      this.bulkDelete = false;
    },
    deleteBulkNow() {
      this.$store.commit("setLoader", true);

      axios
        .postDataWithToken(
          "/auth/bulk-delete-expenses",
          {
            table: "expenses",
            eids: this.selectedExpenses
          },
          this.getAccessToken
        )
        .then(data => {
          this.expenses = data.expenses;
          this.totalExpenses = data.totalExp;
          this.resetVariables();
          this.closeDialog();
          this.$store.commit("setLoader", false);
        });
    },
    previewFile() {
      const file = event.target.files[0];
      this.fileToBeUploadedName = file.name;

      const fileReader = new FileReader();

      fileReader.addEventListener("load", () => {
        this.fileToBeUploaded = fileReader.result;
      });

      fileReader.readAsDataURL(file);
    },
    createBudget() {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/create-budget",
          { dateFrom: this.dateFrom, dateTo: this.dateTo },
          this.getAccessToken
        )
        .then(data => {
          if (data == "success") {
            this.renderBudgets();
            this.resetVariables();
          }
          this.$store.commit("setLoader", false);
        });
    },
    renderBudgets() {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/get-budgets-for-selected-period",
          {
            dateFrom: this.dateFrom,
            dateTo: this.dateTo,
            selectedBudgetCategory: this.selectedBudgetCategory
          },
          this.getAccessToken
        )
        .then(data => {
          this.budgets = data.budgets;
          this.totalBudget = axios.formatMoney(data.totalBud.toFixed(2));
          this.resetVariables();
          this.$store.commit("setLoader", false);
        });
    },
    uploadFile() {
      if (
        this.fileToBeUploaded == null ||
        this.fileToBeUploadedName == null ||
        this.selectedFile == null
      ) {
        alert("Specify the File Type and Then Select A File!");
        return false;
      } else {
        this.$store.commit("setLoader", true);

        const obj = {
          file: this.fileToBeUploaded,
          name: this.fileToBeUploadedName,
          type: this.selectedFile
        };

        axios
          .postDataWithToken(
            "/auth/upload-excel-template",
            obj,
            this.getAccessToken
          )
          .then(excelTemplates => {
            this.$store.commit("setLoader", false);
            this.snackBar = true;
            this.snackText = "File Successfuly Uploaded";
            this.renderBudgets();
          });
      }
    }
  }
};
</script>

<style>
</style>